import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppConfigService } from '../../../config/app-config.service';
import { ServiceResult } from '../../../_models/app-models';
import {
    tblauthentication
} from "../_models/authentication";


let API_REVIEW_FORM_URL;

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  constructor(private http: HttpClient, private appConfigService: AppConfigService) {
    API_REVIEW_FORM_URL = this.appConfigService.getConfigByKey("forms");
  }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  getAuthentication(caseNumber, stateID): Observable<tblauthentication> {
    return this.http
      .get<ServiceResult<tblauthentication>>(API_REVIEW_FORM_URL + '/ReviewFormMFAValidation?caseNumber=' + caseNumber + '&stateID=' + stateID)
      .pipe(map(r => this.extractData(r)));
  }
  extractData(res: any) {
    return res.data;
  }

}
